export const schemaValidateModuleConfigurationsList = [
  {
    id: 1,
    field: "id",
    is_in_bdd:false,
    data_type: "id",
    type: "field",
    max_length: 80,
    component_new:"null",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-xs",
    readmore_limit_table: "null",
    show_export_table: true,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 2,
    field: "field",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,
    regex: "^[A-ZÑa-zñáéíóúÁÉÍÓÚ'°\"\"“”,.()0-9/\\[\\]#->!+@$_&*:;?%<¿¡©®™~=^-|\\n ]+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 3,
    field: "is_in_bdd",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 4,
    field: "data_type",
    is_in_bdd:true,
    data_type: "string",
    type: "relation",
    max_length: 255,
    component_new:"NewCatalogRelationGenericField",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 5,
    field: "type",
    is_in_bdd:true,
    data_type: "string",
    type: "relation",
    max_length: 255,
    component_new:"NewCatalogRelationGenericField",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 6,
    field: "max_length",
    is_in_bdd:true,
    data_type: "number",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: false,
    validate_minimum: true,
    validate_regex: true,
    regex: "^\d+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 7,
    field: "reference_order",
    is_in_bdd:true,
    data_type: "number",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "^\d+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 8,
    field: "show_new",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: true,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 9,
    field: "new_section_order",
    is_in_bdd:true,
    data_type: "number",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "^\d+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 10,
    field: "new_section_field_order",
    is_in_bdd:true,
    data_type: "number",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "^\d+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 11,
    field: "component_new",
    is_in_bdd:true,
    data_type: "string",
    type: "relation",
    max_length: 255,
    component_new:"NewCatalogRelationGenericField",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 12,
    field: "order_new",
    is_in_bdd:true,
    data_type: "number",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: true,
    regex: "^\d+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 13,
    field: "show_view_preview",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 14,
    field: "show_view_full",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 15,
    field: "view_section_order",
    is_in_bdd:true,
    data_type: "number",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "^\d+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 16,
    field: "view_section_field_order",
    is_in_bdd:true,
    data_type: "number",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "^\d+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 17,
    field: "component_view",
    is_in_bdd:true,
    data_type: "string",
    type: "relation",
    max_length: 255,
    component_new:"NewCatalogRelationGenericField",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 18,
    field: "order_view",
    is_in_bdd:true,
    data_type: "number",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: true,
    regex: "^\d+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 19,
    field: "show_in_table",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 19.5,
    field: "show_in_table_pre",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: true,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 20,
    field: "sort_in_table",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 21,
    field: "style_in_table",
    is_in_bdd:true,
    data_type: "string",
    type: "relation",
    max_length: 255,
    component_new:"NewCatalogRelationGenericField",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 22,
    field: "readmore_limit_table",
    is_in_bdd:true,
    data_type: "number",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: true,
    regex: "^\d+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 23,
    field: "show_export_table",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 24,
    field: "is_search_text",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 26,
    field: "is_filter_relation",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 28,
    field: "is_comparable",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 29,
    field: "comparable_relation_condition",
    is_in_bdd:true,
    data_type: "string",
    type: "relation",
    max_length: 255,
    component_new:"NewCatalogRelationGenericField",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 30,
    field: "is_required",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 31,
    field: "validate_minimum",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 32,
    field: "validate_regex",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 80,
    field: "sanitize_mode",
    is_in_bdd:true,
    data_type: "string",
    type: "relation",
    max_length: 16,
    component_new:"NewCatalogRelationGenericField",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 33,
    field: "regex",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 34,
    field: "validate_unique",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 35,
    field: "unique_condition",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 36,
    field: "occupation_new",
    is_in_bdd:true,
    data_type: "number",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: true,
    regex: "^\d+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 36.5,
    field: "occupation_pre",
    is_in_bdd:true,
    data_type: "number",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: true,
    regex: "^\d+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 37,
    field: "occupation_view",
    is_in_bdd:true,
    data_type: "number",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: true,
    regex: "^\d+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 38,
    field: "is_placeholder",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 39,
    field: "css_class",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 40,
    field: "key_relation",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 41,
    field: "data_name",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 42,
    field: "large_description_es",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 43,
    field: "short_description_es",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 46,
    field: "deleted",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 48,
    field: "catalogmodule_id",
    is_in_bdd:true,
    data_type: "integer",
    type: "relation",
    max_length: 150,
    component_new:"NewCatalogRelationGenericField",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-xs",
    readmore_limit_table: "null",
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 49,
    field: "module_text",
    is_in_bdd:true,
    data_type: "string",
    type: "relation",
    max_length: 255,
    component_new:"NewCatalogRelationGenericField",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 50,
    field: "new_edit_premanager",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"NewRadioButtonGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 51,
    field: "content_pre_manager",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 8000,
    component_new:"NewTextGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-xxl",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:12
  },
  {
    id: 52,
    field: "content_manager",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 8000,
    component_new:"NewTextGeneric",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-xxl",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:true,
    occupation_new:12
  },
  {
    id: 53,
    field: "options",
    is_in_bdd:false,
    data_type: "buttons",
    type: "field",
    max_length: "null",
    component_new:"null",
    show_in_table: true,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: "null",
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-module-configuration",
    is_placeholder:false,
    occupation_new:6
  }
];